export const iconsByVehicleVariant = {
    e4c: 'uikit-icon icon-bus',
    nhmr: 'uikit-icon icon-truck',
    tgx: 'uikit-icon icon-truck',
    ican: 'uikit-icon icon-truck',
    vw: 'uikit-icon icon-truck',
    fms: 'uikit-icon icon-van',
    other: 'uikit-icon icon-warning-sign',
    delivery: 'uikit-icon icon-delivery',
    core: 'uikit-icon icon-truck',
    elsa: 'uikit-icon icon-bus',
    true: 'uikit-icon icon-bus',
    unknown: 'uikit-icon icon-truck'
};
